import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/wellbet/images/onboardingLogo.svg';

export default function index() {
  return (
    <Image src={logo} w={['102px', null, 'unset']} mt={['8', null, 'unset']} />
  );
}
